export const INCENTIVE_VARIATION = 'f234999f-7c35-4bf4-9e50-28817e26def4';
